module.exports = __webpack_public_path__ + "img/图片27.0b563a1b.png";